module.exports = __webpack_public_path__ + "static/media/pc-bg.b059441e.png";